import {
	GET_LANGUAGES_REQUEST,
	GET_LANGUAGES_SUCCESS,
	GET_LANGUAGES_ERROR,
	GET_LANGUAGE_REQUEST,
	GET_LANGUAGE_SUCCESS,
	GET_LANGUAGE_ERROR,
	CREATE_LANGUAGE_REQUEST,
	CREATE_LANGUAGE_SUCCESS,
	CREATE_LANGUAGE_ERROR,
	EDIT_LANGUAGE_REQUEST,
	EDIT_LANGUAGE_SUCCESS,
	EDIT_LANGUAGE_ERROR,
	DELETE_LANGUAGE_REQUEST,
	DELETE_LANGUAGE_SUCCESS,
	DELETE_LANGUAGE_ERROR
} from "@/actions"

import {
	languageService
} from "@/services"

const state = {
	languages: [],
	language: {},
	loading: false
}

const sortMap = {
	"spanish": 1,
	"french": 2,
	"german": 3,
	"italian": 4,
	"arabic": 5,
	"mandarin": 6,
	"other": 7,
	"na-or-none": 8,
}

import { addNewFilter, decodeLaravelValidationErrors } from "@/utilities"

const getters = {
	languages: state => state.languages.map(l => ({ ...l, sort: sortMap[l.slug ?? 'other'] })).sort((a, b) => a.sort - b.sort),
	noneLanguageOption: state => state.languages.find(l => l.slug == 'na-or-none')
}

const actions = {
	async getLanguages({ commit }) {
		commit("GET_LANGUAGES_REQUEST")
		const response = await languageService.getLanguages();
		const { status, data } = response
		switch (status) {
			case 200:
				commit("GET_LANGUAGES_SUCCESS", data)
				break
			default:
				commit("GET_LANGUAGES_ERROR", data)
		}
		return response
	},
	async getLanguage({ commit }, params) {
		commit("GET_LANGUAGE_REQUEST")
		const response = await languageService.getLanguage(params)
		const { status, data } = response
		switch (status) {
			case 200:
				commit("GET_LANGUAGE_SUCCESS", data)
				break
			default:
				commit("GET_LANGUAGE_ERROR", data)
				break
		}
		return response
	},
	async createLanguage({ commit, dispatch }, params) {
		commit("CREATE_LANGUAGE_REQUEST")
		const response = await languageService.createLanguage(params)
		const { status, data } = response
		switch (status) {
			case 200:
				if (data?.success) {
					commit("CREATE_LANGUAGE_SUCCESS", data);
					dispatch("alert/createAlertSuccess", "Language created successfully", {
						root: true
					});
				}

				if (data?.error || data?.errors) {
					commit("CREATE_LANGUAGE_ERROR");
					dispatch("alert/createAlertError", data?.errors ? decodeLaravelValidationErrors(data.errors) : "Opps. Something went wrong. Language not created", { root: true });
				}

				break
			default:
				commit("CREATE_LANGUAGE_ERROR")
		}
		return response
	},
	async editLanguage({ commit, dispatch }, params) {
		commit("EDIT_LANGUAGE_REQUEST")
		const response = await languageService.editLanguage(params)
		const { status, data } = response
		switch (status) {
			case 200:
				if (data?.success) {
					commit("EDIT_LANGUAGE_SUCCESS", data);
					dispatch("alert/createAlertSuccess", "Language updated successfully", {
						root: true
					});
				}

				if (data?.error || data?.errors) {
					commit("EDIT_LANGUAGE_ERROR");
					dispatch("alert/createAlertError", data?.errors ? decodeLaravelValidationErrors(data.errors) : "Opps. Something went wrong. Language not updated", { root: true });
				}
				break
			default:
				commit("EDIT_LANGUAGE_ERROR", data)
		}
		return response
	},
	async deleteLanguage({ commit, dispatch }, uuid) {
		commit("DELETE_LANGUAGE_REQUEST")
		const response = await languageService.deleteLanguage(uuid)
		const { status, data } = response
		switch (status) {
			case 200:
				if (data?.success) {
					const { language } = data
					commit("DELETE_LANGUAGE_SUCCESS", { ...language, uuid });
					dispatch("alert/createAlertSuccess", "Language deleted successfully", {
						root: true
					});
				}

				if (data?.error || data?.errors) {
					commit("DELETE_LANGUAGE_ERROR");
					dispatch("alert/createAlertError", data?.errors ? decodeLaravelValidationErrors(data.errors) : "Opps. Something went wrong. Language not deleted", { root: true });
				}
				break
			default:
				commit("DELETE_LANGUAGE_DELETE", data)
		}
		return response
	}
}

const mutations = {
	[GET_LANGUAGES_REQUEST]: state => {
		state.loading = true
	},
	[GET_LANGUAGES_SUCCESS]: (state, data) => {
		const languages = data.languages
		state.languages = addNewFilter(state.languages, languages)
		state.loading = false
	},
	[GET_LANGUAGES_ERROR]: state => {
		state.loading = false
		state.error = true
	},
	[GET_LANGUAGE_REQUEST]: state => {
		state.loading = true
	},
	[GET_LANGUAGE_SUCCESS]: (state, data) => {
		const language = { ...data.language }
		state.language = language
		state.loading = false
	},
	[GET_LANGUAGE_ERROR]: (state, data) => {
		state.loading = false
	},

	[CREATE_LANGUAGE_REQUEST]: state => {
		state.loading = true
	},
	[CREATE_LANGUAGE_SUCCESS]: (state, data) => {
		const { language } = data
		state.languages = addNewFilter(state.languages, [language])
		state.loading = false
	},
	[CREATE_LANGUAGE_ERROR]: state => {
		state.loading = false
	},

	[EDIT_LANGUAGE_REQUEST]: state => {
		state.loading = true
	},
	[EDIT_LANGUAGE_SUCCESS]: (state, data) => {
		const { language } = data
		state.languages = addNewFilter(state.languages, [language])
		state.loading = false
	},
	[EDIT_LANGUAGE_ERROR]: state => {
		state.loading = false
	},

	[DELETE_LANGUAGE_REQUEST]: state => {
		state.loading = true
	},
	[DELETE_LANGUAGE_SUCCESS]: (state, language) => {
		const { deleted_at, uuid } = language

		if (!isEmpty(deleted_at)) {
			state.languages = addNewFilter(state.languages, [language])
		} else {
			state.languages = state.languages.filter(l => l.uuid !== uuid)
		}

		state.loading = false
	},
	[DELETE_LANGUAGE_ERROR]: (state) => {
		state.loading = false
	}

}

export const language = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}